import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-options-dialog',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">Options</h4>
        </div>
        <div class="modal-body" (keyup.esc)="close()">
            <div [innerHTML]="html"></div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    styles: [''],
    standalone: false
})
export class OptionsDialogComponent {
    result = new Subject<any>();
    html: string;

    close() {
        this.result.next(null);
    }
}
